import * as api from './log.api';

import {
  FETCH_LOGS,
  FETCH_LOGS_FILTER_OPTIONS,
  EXPORT_LOGS,
  FetchLogsAction,
  OpenSearchLogFilterCriteriaDTO,
  ExportLogsAction,
  FetchLogsFilterOptionsAction,
  SetFilterOptionsAction,
  SET_FILTER_OPTIONS,
  GetOpenSearchLogFilterValuesDTO
} from './log.types';

export function getAllLogs(size: number, from: number, criteria: OpenSearchLogFilterCriteriaDTO): FetchLogsAction {
  return {
    type: FETCH_LOGS,
    payload: api.getLogs(size, from, criteria),
  };
}

export function exportLogs(criteria: OpenSearchLogFilterCriteriaDTO): ExportLogsAction {
  return {
    type: EXPORT_LOGS,
    payload: api.exportLogs(criteria),
  };
}

export function getFilterOptions(criteria: OpenSearchLogFilterCriteriaDTO): FetchLogsFilterOptionsAction {
  return {
    type: FETCH_LOGS_FILTER_OPTIONS,
    payload: api.getFilterOptions(criteria),
  };
}

export function setFilterOptions(filterOptions: GetOpenSearchLogFilterValuesDTO): SetFilterOptionsAction {
  return {
    type: SET_FILTER_OPTIONS,
    payload: filterOptions,
  };
}
